/**
 * A person's employment status. primary owns this vocabulary — it is a column on patients,
 * guarantors, and patient insurance information.
 *
 * Adding a value requires a migration widening the check constraints on both `patients` and
 * `patient_insurance_information`.
 */
export var EmploymentStatus;
(function (EmploymentStatus) {
    EmploymentStatus["Disabled"] = "DISABLED";
    EmploymentStatus["Employed"] = "EMPLOYED";
    EmploymentStatus["NotEmployed"] = "NOT_EMPLOYED";
    EmploymentStatus["FullTime"] = "FULL_TIME";
    EmploymentStatus["OnActiveMilitaryDuty"] = "ON_ACTIVE_MILITARY_DUTY";
    EmploymentStatus["Other"] = "OTHER";
    EmploymentStatus["PartTime"] = "PART_TIME";
    EmploymentStatus["Retired"] = "RETIRED";
    EmploymentStatus["RetiredMilitary"] = "RETIRED_MILITARY";
    EmploymentStatus["SelfEmployed"] = "SELF_EMPLOYED";
    EmploymentStatus["StudentFullTime"] = "STUDENT_FULL_TIME";
    EmploymentStatus["StudentPartTime"] = "STUDENT_PART_TIME";
    EmploymentStatus["Unknown"] = "UNKNOWN";
    EmploymentStatus["Minor"] = "MINOR";
})(EmploymentStatus || (EmploymentStatus = {}));
//# sourceMappingURL=employmentStatus.js.map